<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_link_setting'"></div>
        </div>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.title_desc_link_tenant1'"/>
                <el-tooltip effect="dark" placement="top-start">
                    <div slot="content" style="text-align:left" v-t="'message.hint_accessible_tenant'"></div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
                <div class="title-box-right">
                    <button class="transparent" type="button" v-on:click="showAddLinkTenantDialog('import')"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                </div>
            </div>
        </div>
        <table width="100%">
            <tr v-if="linkTenantInfo.importTenantList.length > 0" style="background-color: #f6f6f6">
                <td class="object-title" width="25%" style="padding-left:20px" v-t="'message.item_tenant_name'"></td>
                <td class="object-title" width="25%">
                    <span  v-t="'message.item_link_admin'"/>
                    <el-tooltip effect="dark" placement="top-start">
                        <div slot="content" style="text-align:left" v-html="$t('message.hint_admin_accessible_tenant')"></div>
                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                    </el-tooltip>
                </td>
                <td class="object-title" width="20%" v-t="'message.item_status'"></td>
                <td class="object-title" width="15%"></td>
                <td class="object-title" width="15%"></td>
            </tr>
            <tr v-for="linkTenant in linkTenantInfo.importTenantList">
                <template v-if="linkTenant.deletedOrTerminated">
                    <td class="object-value" width="25%" style="padding-left:20px">{{ linkTenant.tenantName }}<span v-t="'message.item_link_end'"></span></td>
                </template>
                <template v-else>
                    <td class="object-value" width="25%" style="padding-left:20px">{{ linkTenant.tenantName }}</td>
                </template>
                <td class="object-value" width="25%">
                    <span v-if="linkTenant.state != 1">
                        {{ linkTenant.wantUserName }}@{{ appData.tenantList[0].name }}
                    </span>
                    <span v-else>
                        -
                    </span>
                </td>
                <td class="object-value" width="20%">
                    {{ getLinkStatusName('import', linkTenant.state) }}
                </td>
                <template v-if="linkTenant.deletedOrTerminated">
                    <td class="object-value" width="15%" style="text-align:right"></td>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button class="transparent-button" type="button" v-on:click="showDeleteLinkTenantDialog('importForceUnLink',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_delete_link'"></span>
                        </button>
                    </td>
                </template>
                <template v-else>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button v-if="linkTenant.state == 2" class="transparent-button" type="button" v-on:click="showConfirmGroupAndUser('import',linkTenant)">
                            <span style="color: #5171cb" v-t="'message.action_confirm'"></span>
                        </button>
                        <button v-else-if="linkTenant.state == 1" class="transparent-button" type="button" v-on:click="connectTenantRequest('import',linkTenant)">
                            <span style="color: #5171cb" v-t="'message.action_connect_link'"></span>
                        </button>
                    </td>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button v-if="linkTenant.state == 2" class="transparent-button" type="button" v-on:click="disconnectTenantRequest('import',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_disconnect_link'"></span>
                        </button>
                        <button v-else class="transparent-button" type="button" v-on:click="showDeleteLinkTenantDialog('import',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_delete_link'"></span>
                        </button>
                    </td>
                </template>
            </tr>
        </table>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.title_desc_link_tenant2'"/>
                <el-tooltip effect="dark" placement="top-start" style="clear:both">
                    <div slot="content" style="text-align:left" v-t="'message.hint_allowed_tenant'"></div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
                <div class="title-box-right">
                    <button class="transparent" type="button" v-on:click="showAddLinkTenantDialog('export')"><img src="../../../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                </div>
            </div>
        </div>
        <table width="100%">
            <tr v-if="linkTenantInfo.exportTenantList.length > 0" style="background-color: #f6f6f6">
                <td class="object-title" width="25%" style="padding-left:20px" v-t="'message.item_tenant_name'"></td>
                <td class="object-title" width="25%">
                    <span  v-t="'message.item_link_admin'"/>
                    <el-tooltip effect="dark" placement="top-start">
                        <div slot="content" style="text-align:left" v-html="$t('message.hint_admin_allowed_tenant')"></div>
                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                    </el-tooltip>
                </td>
                <td class="object-title" width="20%" v-t="'message.item_status'"></td>
                <td class="object-title" width="15%"></td>
                <td class="object-title" width="15%"></td>
            </tr>
            <tr v-for="linkTenant in linkTenantInfo.exportTenantList">
                <template v-if="linkTenant.deletedOrTerminated">
                    <td class="object-value" width="25%" style="padding-left:20px">{{ linkTenant.tenantName }}<span v-t="'message.item_link_end'"></span></td>
                </template>
                <template v-else>
                    <td class="object-value" width="25%" style="padding-left:20px">{{ linkTenant.tenantName }}</td>
                </template>
                <td class="object-value" width="25%">
                    <span v-if="linkTenant.state != 1">
                        {{ linkTenant.wantUserName }}@{{ linkTenant.tenantName }}
                    </span>
                    <span v-else>
                        -
                    </span>
                </td>
                <td class="object-value" width="20%">
                    {{ getLinkStatusName('export', linkTenant.state) }}
                </td>
                <template v-if="linkTenant.deletedOrTerminated">
                    <td class="object-value" width="15%" style="text-align:right"></td>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button class="transparent-button" type="button" v-on:click="showDeleteLinkTenantDialog('exportForceUnLink',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_delete_link'"></span>
                        </button>
                    </td>
                </template>
                <template v-else>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button v-if="linkTenant.state == 2" class="transparent-button" type="button" v-on:click="showConfirmGroupAndUser('export',linkTenant)">
                            <span style="color: #5171cb" v-t="'message.action_confirm'"></span>
                        </button>
                        <button v-else-if="linkTenant.state == 0" class="transparent-button" type="button" v-on:click="checkPerformAllowLink(linkTenant)">
                            <span style="color: #5171cb" v-t="'message.action_connect_link'"></span>
                        </button>
                    </td>
                    <td class="object-value" width="15%" style="text-align:right">
                        <button v-if="linkTenant.state == 2" class="transparent-button" type="button" v-on:click="disconnectTenantRequest('export',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_disconnect_link'"></span>
                        </button>
                        <button v-else class="transparent-button" type="button" v-on:click="showDeleteLinkTenantDialog('export',linkTenant)">
                            <span style="color: #d55169" v-t="'message.action_delete_link'"></span>
                        </button>
                    </td>
                </template>
            </tr>
        </table>
        <addlinktenant v-if="showAddLinkTenant" :linkType="linkType" :appData='appData' @save="connectTenant" @cancel="showAddLinkTenant=false"></addlinktenant>
        <deletelinktenant v-if="showDeleteLinkTenant" :confirmInfo="confirmInfo" @delete="deleteLinkTenant" @cancel="showDeleteLinkTenant=false"></deletelinktenant>
        <listuser v-if="showConfirmExternalObject" :appData="appData" :tenantId="targetTenantId" :type="targetType" :confirmOnly="confirmOnly" @ok="showConfirmExternalObject=false" @save="disconectAfterRemove" @cancel="showConfirmExternalObject=false"></listuser>
        <confirmtenantlink v-if="showConfirmTenantLink" :confirmInfo="confirmInfo" @allowLink="allowLinkTenant()" @confirm="showConfirmTenantLink=false" @cancel="cancelConfirmTenantLink()" ></confirmtenantlink>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import AddLinkTenant from "@/components/pc/setting/linktenant/LinkTenantSettingAdd.vue";
import ConfirmTenantLink from "@/components/pc/setting/linktenant/LinkTenantSettingConfirm.vue"
import ListUser from '@/components/pc/setting/linktenant/LinkTenantSettingListUser.vue';
import DeleteObject from '../../../DeleteObject.vue';
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';

const REQUEST_TENANT_INFO_WITH_DELETED_OR_TERMINATED = 3;

export default {
    components: {
        addlinktenant: AddLinkTenant,
        deletelinktenant: DeleteObject,
        listuser: ListUser,
        confirmtenantlink: ConfirmTenantLink
    },

    data() {
        return {
            showAddLinkTenant: false,
            showDeleteLinkTenant: false,
            showConfirmExternalObject: false,
            showConfirmTenantLink: false,
            confirmOnly: false,
            managementUserRights: false,
            linkTenantInfo: {
                importTenantList: [],
                exportTenantList: []
            },
            linkType: 0,
            linkDescription: null,
            targetTenantId : 0,
            targetType : null,
            deleteTarget: {
                linkType: 0,
                tenant: null,
            },
            targetTenant: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
                linkType: 0,
                tenantName: null,
                connect: false,
                allowCheck: false
            },
        };
    },
    methods: {
        getTenantConnectInfo: function() {
            let self = this;
            self.appData.importedTenantList = [];
            self.appData.exportedTenantList = [];
            server.post('/gettenantconnectinfo',{type: REQUEST_TENANT_INFO_WITH_DELETED_OR_TERMINATED})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.linkTenantInfo = res.data;
                            self.appData.importedTenantList = [];
                            let actionRequireTenantCount = 0;
                            self.appData.importedTenantList = res.data.importTenantList;
                            self.appData.exportedTenantList = res.data.exportTenantList;
                            for (let importTenant of self.appData.importedTenantList) {
                                if (importTenant.state == constants.TENANT_CONNECT_ALLOW) {
                                    actionRequireTenantCount ++;
                                }
                            }
                            for (let exportTenant of self.appData.exportedTenantList) {
                                if (exportTenant.state == constants.TENANT_CONNECT_WANT) {
                                    actionRequireTenantCount ++;
                                }
                            }
                            self.appData.actionRequireTenantCount = actionRequireTenantCount;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTenantConnectInfo").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantConnectInfo", error);
                });
        },
        connectTenantRequest(type,tenant) {
            if (!this.managementUserRights) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_link_by_denied"));
                return;
            }
            let linkType;
            if (type == "import") {
                linkType = constants.TENANT_CONNECT_WANT;
            } else {
                linkType = constants.TENANT_CONNECT_ALLOW;
            }
            this.connectTenant(linkType, tenant.tenantName ,1);
        },
        connectTenant(linkType, tenantName, requestType) {
            this.showAddLinkTenant = false;
            let self = this;
            server.post('/connecttenant' , {linkType: linkType , destinationTenantName: tenantName} )
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getTenantConnectInfo();
                            if (requestType == 0) {
                                self.confirmInfo.tenantName = tenantName;
                                self.confirmInfo.linkType = linkType;
                                self.confirmInfo.connect = true;
                                self.confirmInfo.allowLink = false;
                                self.showConfirmTenantLink = true;
                            } else {
                                commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_link_connected").replace("{tenantName}",tenantName));
                            }
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_link_by_denied"));
                            break;
                        case constants.STATUS_ERROR_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_link_tenant_not_found"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_link_tenant_already_exist"));
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED_OR_TERMINATED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_link_tenant_already_deleted_or_terminated"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","connectTenant").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "addLinkTenant", error);
                });
        },
        disconnectTenantRequest(type,tenant) {
            let linkType;
            if (type == "import") {
                linkType = constants.TENANT_CONNECT_WANT;
                if (!commonUtil.isTenantConnectAdmin(this.appData, tenant.tenantId)) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_disconnect_link_denied"));
                    return;
                }
            } else if (type == "export") {
                linkType = constants.TENANT_CONNECT_ALLOW;
                if (!this.managementUserRights) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_disconnect_link_denied"));
                    return;
                }
            }

            this.disconnectTenant(linkType, tenant, 1);
        },
        allowLinkTenant() {
            this.showConfirmTenantLink = false;
            this.confirmInfo.allowCheck = false;
            this.connectTenantRequest('export',this.targetTenant)
        },
        cancelConfirmTenantLink(){
            this.showConfirmTenantLink = false;
            this.confirmInfo.allowCheck = false;
        },
        deleteLinkTenant() {
            this.disconnectTenant(this.deleteTarget.linkType, this.deleteTarget.tenant, 0);
        },
        disconnectTenant(linkType, tenant, requestType) {
            this.showDeleteLinkTenant = false;
            let self = this;
            server.post('/disconnecttenant' , {linkType: linkType, destinationTenantId: tenant.tenantId } )
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getTenantConnectInfo();
                            if (requestType == 0) {
                                commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_link_deleted"));
                            } else {
                                self.confirmInfo.tenantName = tenant.tenantName;
                                self.confirmInfo.linkType = linkType;
                                self.confirmInfo.connect = false;
                                self.showConfirmTenantLink = true;
                            }
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_disconnect_link_denied"));
                            break;
                        case constants.STATUS_ERROR_USER_EXISTS:
                            if (linkType == constants.TENANT_CONNECT_WANT) {
                                self.deleteTarget.linkType = linkType;
                                self.deleteTarget.tenant = tenant;
                                self.targetTenantId = tenant.tenantId;
                                self.targetType = "import";
                                self.confirmOnly = false;
                                self.showConfirmExternalObject = true;
                            } else {
                                commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_disconnect_link_exit_user"));
                            }
                            break;
                        case constants.STATUS_ERROR_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_link_already_deleted"));
                            self.getTenantConnectInfo();
                            break;
                        case constants.STATUS_ERROR_TOO_MANY_DELETE_USERS:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n,"error_too_many_delete_users"))
                            break;
                        case constants.STATUS_ERROR_ALREADY_CHANGE_STATUS:
                            commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n,"error_already_change_status"))
                            self.getTenantConnectInfo();
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","disconnectTenant").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "deleteLinkTenant", error);
                });
        },
        disconectAfterRemove(userList) {
            this.showConfirmExternalObject = false;

            let operations = [];

            // create removefromtalkgroup request parameter
            for (let userTalkgroup of userList) {
                operations.push({
                    command: "removefromtalkgroup",
                    operation: {
                        tenantId: userTalkgroup.talkgroupTenantId,
                        talkgroupId: userTalkgroup.talkgroupId,
                        userTenantId: userTalkgroup.userTenantId,
                        userId: userTalkgroup.userId
                    }
                })
            }

            let self = this;

            server.post('/multiop', {operations: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.disconnectTenant(this.deleteTarget.linkType, this.deleteTarget.tenant, 1)
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_link_user_delete_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","disconectAfterRemove").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "disconectAfterRemove", error);
                });
        },
        getUserRights() {
            let self = this;
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, id: this.appData.loginUserObjectId, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.managementUserRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                        break;
                    case constants.STATUS_ERROR_DENIED:
                    case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_confirm_link_user"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkCreditCardInfo", error);
            });
        },
        showAddLinkTenantDialog(type) {
            if (!this.managementUserRights) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_link_denied"));
                return;
            }

            if (type == "import") {
                this.linkType = constants.TENANT_CONNECT_WANT;
            } else {
                this.linkType = constants.TENANT_CONNECT_ALLOW;
            }
            this.showAddLinkTenant = true;
        },
        showDeleteLinkTenantDialog(type,linkTenant) {
            if (!this.managementUserRights) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_delete_link_denied"));
                return;
            }
            this.deleteTarget.tenant = linkTenant;
            this.confirmInfo.objectName = linkTenant.tenantName;
            if (type == "import") {
                this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_desc_link_tenant1");
                this.deleteTarget.linkType = constants.TENANT_CONNECT_WANT;
            } else if (type == "export") {
                this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_desc_link_tenant2");
                this.deleteTarget.linkType = constants.TENANT_CONNECT_ALLOW;
            }else if (type == "importForceUnLink") {
                this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_desc_link_tenant1");
                this.deleteTarget.linkType = constants.TENANT_CONNECT_IMPORT_FORCE_UNLINK;
            } else if (type == "exportForceUnLink") {
                this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"title_desc_link_tenant2");
                this.deleteTarget.linkType = constants.TENANT_CONNECT_EXPORT_FORCE_UNLINK;
            } else {
                return;
            }

            this.showDeleteLinkTenant = true;
        },
        showConfirmGroupAndUser(type, tenant) {
            if (!this.managementUserRights) {
                commonUtil.notifyMessage(this, "Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_confirm_link_denied"));
                return;
            }
            this.confirmOnly = true;
            this.targetType = type;
            this.targetTenantId = tenant.tenantId;
            this.showConfirmExternalObject = true;
        },
        getLinkStatusName(type, state) {
            return commonUtil.getLinkStatusName(this.$i18n, type, state);
        },
        checkPerformAllowLink(linkTenant) {
            this.targetTenant = linkTenant;
            this.confirmInfo.tenantName = linkTenant.tenantName;
            this.confirmInfo.linkType = constants.TENANT_CONNECT_ALLOW;
            this.confirmInfo.connect = true;
            this.confirmInfo.allowCheck = true;
            this.showConfirmTenantLink = true;
        }
    },
    mounted: function() {
        this.getTenantConnectInfo();
    },
    created: function() {
        this.getUserRights();
    },
    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                return this.getInfo();
            }
        },
        '$route' (to, from) {
            if (to.name == "Setting") {
                if ((this.appData.importedTenantList.length > 0) || (this.appData.exportedTenantList.length > 0)) {
                    this.getTenantConnectInfo();
                }
            }
        }
    },
    props: [ 'appData' , 'badgeItem' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.icon-help {
    height: 14px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

</style>